import {
  Intro,
  Gallery,
  // Navbar,
  Navbar2,
  Impact,
  Featured,
  Testimonials,
  ContactUs,
  Footer,
} from '../components'

// import curvePath from '../assets/curvePath.svg'
// import curvePath2 from '../assets/curvePath2.svg'

function Home() {
  return (
    <div>
      <div className='lg:max-w-7xl sm:w-full mx-auto'>
        {/* <Navbar /> */}
        <Navbar2 />
        <div className='px-4 relative items-center'>
          <h1 className='font-semibold mt-30 md:mt-40 text-7xl md:text-9xl'>सेवा परमो धर्मः</h1>
          <p className='font-normal italic mt-6 text-2xl max-w-xl'>
            To serve a life is to live a life.
          </p>
        </div>
      </div>
      {/* <img src={curvePath} alt='curve path' className='w-full mt-60 z-40' /> */}

      {/* <div className='curvepath z-0'>
        <svg
          className='z-0'
          data-name='Layer 1'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1200 120'
          preserveAspectRatio='none'
        >

          <path
            d='M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z'
            class='shape-fill'
          ></path>

        </svg>
      </div> */}

      <Intro />
      <Gallery />
      <Impact title background />
      <Featured />
      <Testimonials />
      <ContactUs />
      <Footer support />
    </div>
  )
}

export default Home
